import { FeedPost, IndirectModal, ThreadPost } from "components";
import FeedIncident from "components/files/feed/FeedIncident";
import FeedPost3 from "components/files/feed/FeedPost3";
import FeedPost4 from "components/files/feed/FeedPost4";
import ProfileHeader from "components/files/profile/ProfileHeader";
import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Button } from "ui";

export type ProfileSections =
    | "posts"
    | "incidents"
    | "replies"
    | "media"
    | "likes";

const Profile = () => {
    const [section, setSection] = useState<ProfileSections>("posts");

    // const [inDirectFollowers, setInDirectFollowers] = useState(false);
    // const [showFollowers, setShowFollowers] = useState(false);

    // const handleOpenProfile = (attr: 0 | 1) => {
    //     if (attr) {
    //         setInDirectFollowers(true);
    //     } else {
    //         setInDirectFollowers(false);
    //     }
    //     setShowFollowers(true);
    // };

    const [openIdirectModal, setOpenIdirectModal] = useState(false);

    return (
        <FeedLayout pageTitle="profile">
            {/* {!showFollowers ? ( */}
            {/* <> */}
            <ProfileHeader setOpenIdirectModal={setOpenIdirectModal} />
            <div id="profile-timeline-posts" className="box-heading">
                <Button
                    text="Posts"
                    color=""
                    className={section == "posts" ? "is-active" : ""}
                    handleClick={() => setSection("posts")}
                />
                <Button
                    text="Incidents"
                    color=""
                    className={section == "incidents" ? "is-active" : ""}
                    handleClick={() => setSection("incidents")}
                />
                <Button
                    text="Replies"
                    color=""
                    className={section == "replies" ? "is-active" : ""}
                    handleClick={() => setSection("replies")}
                />
                <Button
                    text="Media"
                    color=""
                    className={section == "media" ? "is-active" : ""}
                    handleClick={() => setSection("media")}
                />
                <Button
                    text="Likes"
                    color=""
                    className={section == "likes" ? "is-active" : ""}
                    handleClick={() => setSection("likes")}
                />
            </div>

            <div className="profile-sections pr-10 pl-10 pt-20 pb-20">
                <div
                    className={`profile-section profile-posts-section ${section != "posts" ? "is-hidden" : ""}`}
                >
                    <ThreadPost />
                    <FeedPost />
                </div>
                <div
                    className={`profile-section profile-incidents-section ${section != "incidents" ? "is-hidden" : ""}`}
                >
                    <FeedIncident />
                </div>
                <div
                    className={`profile-section profile-replies-section ${section != "replies" ? "is-hidden" : ""}`}
                >
                    <FeedPost4 />
                </div>
                <div
                    className={`profile-section profile-media-section ${section != "media" ? "is-hidden" : ""}`}
                >
                    <ThreadPost />
                    <FeedPost />
                    <FeedPost4 />
                    <FeedIncident />
                </div>
                <div
                    className={`profile-section profile-likes-section ${section != "likes" ? "is-hidden" : ""}`}
                >
                    <FeedPost3 />
                </div>
            </div>
            {/* </>
            ) : (
                <ProfileFollowers
                    inDirectFollowers={inDirectFollowers}
                    setIndirectFollowers={setInDirectFollowers}
                    setShowFollowers={setShowFollowers}
                />
            )} */}
            <IndirectModal
                open={openIdirectModal}
                setOpen={setOpenIdirectModal}
            />
        </FeedLayout>
    );
};

export default Profile;
